import * as React from 'react';
import { AgendaEventViewAllDay, AgendaEventViewNormal } from 'owa-agenda-event-views-wrappers';
import agendaItemSelected from '../actions/agendaItemSelected';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { fetchCalendarEventDetails } from 'owa-publishedcalendar-eventdetails';
import getAgendaItem from '../selectors/getAgendaItem';
import { getCalendarEventColorScheme } from 'owa-calendar-color-resolver';
import isSelectedCalendarEvent from '../selectors/isSelectedCalendarEvent';
import { observer } from 'mobx-react-lite';
import { updateModuleCommand } from 'owa-publishedcalendar-settings';
import updateSelectedCalendarEvent from '../actions/updateSelectedCalendarEvent';

/**
 * Calendar agenda event controller properties
 */
export interface CalendarAgendaEventViewControllerProps {
    event: CalendarEvent;
}

/**
 * Calendar agenda event controller
 */
export default observer(function CalendarAgendaEventViewController(
    props: CalendarAgendaEventViewControllerProps
) {
    const { event } = props;

    const onClick = React.useCallback(
        evt => {
            openItemDetails(event);
        },
        [event]
    );

    const onDoubleClick = React.useCallback(
        evt => {
            // Opens ItemDetails on both single and double click
            openItemDetails(event);
        },
        [event]
    );

    const agendaItem = getAgendaItem(event);
    const viewProps = {
        onClick: onClick,
        onDoubleClick: onDoubleClick,
        colorScheme: getCalendarEventColorScheme(event),
        isSelected: isSelectedCalendarEvent(event),
    };

    let AgendaEventView;
    if (agendaItem.isAllDay) {
        AgendaEventView = AgendaEventViewAllDay;
    } else {
        AgendaEventView = AgendaEventViewNormal;
    }
    return <AgendaEventView {...viewProps} {...agendaItem} />;
});

/**
 * Opens ItemDetails (CalendarReadingPane)
 */
function openItemDetails(event: CalendarEvent) {
    updateSelectedCalendarEvent(event);
    agendaItemSelected();
    fetchCalendarEventDetails(event, false /*fetchSeriesMaster*/);
    updateModuleCommand('Open_ItemDetails');
}
